import React, { useEffect } from 'react'
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material'

function ConfirmRestartModal() {
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [])

  const handleCancel = () => {
    const closeButton = window.parent.document.querySelector(
      '#restartProgramConfirmationPopup .closeIcon'
    ) as HTMLElement
    closeButton.click()
  }
  const handleRestart = () => {
    window.parent.postMessage({ type: 'restart-programs-confirmed' }, '*')
    handleCancel()
  }

  return (
    <Box sx={{ overflow: 'hidden' }}>
      <Typography variant='h5' sx={{ mb: 1 }}>
        Restart Programs
      </Typography>
      <DialogContent>
        <Typography>
          Are you sure you want to restart the program for the selected
          students?
          <br />
          This will permanently delete all current progress and data and cannot
          be undone. When these students next sign in to XtraMath, they will
          begin the program again from the start.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ mt: 3 }}>
        <Button
          variant='text'
          sx={{ color: 'common.black' }}
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button variant='text' color='error' onClick={handleRestart}>
          Restart
        </Button>
      </DialogActions>
    </Box>
  )
}

export default ConfirmRestartModal
